import { FC } from 'react';

// ─────────────────────────────────────────────
// Toast
//
// 화면 하단 중앙에 떠오르는 토스트 메시지(다크 알약 + fade in/out).
// 상태는 useToast 훅이 관리하고, 이 컴포넌트는 표시만 한다.
// 애니메이션 길이를 durationMs(자동 소멸 시간)와 동기화해 소멸 시점에 맞춰 사라진다.
// ─────────────────────────────────────────────

export interface ToastProps {
  /** 표시할 메시지 (null이면 렌더하지 않음) */
  message: string | null;
  /** 자동 소멸 시간(ms) = fade 애니메이션 길이. 기본 4000 */
  durationMs?: number;
}

export const Toast: FC<ToastProps> = ({ message, durationMs = 4000 }) => {
  if (!message) return null;

  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-8 z-[100] flex justify-center">
      <div
        className="animate-toast-fade rounded-lg bg-gray-800 px-4 py-2 text-sm font-medium text-white shadow-lg"
        style={{ animationDuration: `${durationMs}ms` }}
      >
        {message}
      </div>
      <style>{`
        @keyframes toastFade {
          0% { opacity: 0; transform: translateY(8px); }
          15% { opacity: 1; transform: translateY(0); }
          75% { opacity: 1; transform: translateY(0); }
          100% { opacity: 0; transform: translateY(-4px); }
        }
        .animate-toast-fade {
          animation-name: toastFade;
          animation-timing-function: ease-in-out;
          animation-fill-mode: forwards;
        }
      `}</style>
    </div>
  );
};
